import {
    filters,
    jsonApiFilter,
    jsonApiInclude,
    jsonApiSort,
    preprocessJsonApiQuery,
} from '@dmp/shared/json-api-request';
import * as z from 'zod';

export const authGroupsFilter = filters({
    nameIn: {
        type: 'in',
        field: 'name',
    },
});

export const authGroupsQueryValidator = z.preprocess(
    preprocessJsonApiQuery,
    z.object({
        filter: jsonApiFilter(authGroupsFilter),
        include: jsonApiInclude(['teams']),
        sort: jsonApiSort(['name', 'permissionGroup']),
    })
);

export type AuthGroupsQuery = z.output<typeof authGroupsQueryValidator>;
